import axios from './axios'
import { GetToken, clear } from '../libs/util'
import { Message, Modal } from 'view-design'

/**
 *
 * @param url       请求路径
 * @param data      请求参数
 * @param config    配置信息
 *          sendToken   是否需要带上token
 *          showErrMsg  是否显示错误信息
 */

class HttpLoadingManager {
    static httpMap = {} //当前请求队列
    static loadingTimer: any //定时器
    static closeTimer: any
    static show = false

    //第一个请求显示loading
    static showLoading(func: any) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
        this.httpMap[func] = true
        if (Object.keys(this.httpMap).length === 1) {
            this.openLoadingTimer()
        }
    }
    static messageDestroy() {
        this.show = false
        ;(Message as any).destroy()
    }

    //初始化
    static initHttpLoading() {
        this.httpMap = {}
        this.closeLoadingTimer()
        this.messageDestroy()
    }

    //请求回调删除func httpmap为空时 清除loading
    static closeLoading(func: any) {
        delete this.httpMap[func]
        this.closeTimer = setTimeout(() => {
            if (Object.keys(this.httpMap).length === 0) {
                this.closeLoadingTimer()
                this.messageDestroy()
            }
        }, 50)
    }

    //清除定时器
    static closeLoadingTimer() {
        clearTimeout(this.loadingTimer)
        this.loadingTimer = null
    }

    //开启定时器loading提示
    static openLoadingTimer() {
        this.closeLoadingTimer()
        if (!this.show) {
            this.show = true
            ;(Message as any).loading({
                content: 'Loading...',
                duration: 0
            })
        }
    }

    //请求失败关闭清空map关闭loading
    static loadingError(errorInfo) {
        this.initHttpLoading()
        ;(Message as any).error(errorInfo)
    }

    static GoLogin() {
        clear()
        setTimeout(() => {
            window.location.reload()
        }, 500)
    }

    // 清除 token 并跳转登录页
    static tokenError() {
        HttpLoadingManager.initHttpLoading()
        clear()
        ;(Modal as any).error({
            title: '登录信息失效',
            content: '登录信息已失效，请重新登录',
            onOk: this.GoLogin,
            onCancel: this.GoLogin
        })
    }
}

const Post = (func, data = {}, conf = {}) => {
    let config = {
        showLoading: true,
        sendToken: true,
        showErrMsg: true,
        ...conf
    }
    let url = 'topM/'
    // 是否带上token
    if (config.sendToken) {
        let token = GetToken()
        url += url.indexOf('?') >= 0 ? '&' : '?'
        url += `uid=${token.uid}&token=${token.token}`
    } else {
        url = 'login/topManager'
    }
    if (config.showLoading) {
        HttpLoadingManager.showLoading(func)
    }
    return new Promise((resolve, reject) => {
        axios
            .request({
                url: url,
                data: {
                    _mod: 'topManager',
                    _func: func,
                    _check: '',
                    _param: data
                },
                method: 'POST',
                timeout: 30000
            })
            .then((res) => {
                let data = res.data
                if (data._errno) {
                    if (data._errno == 401) {
                        HttpLoadingManager.tokenError()
                    } else {
                        HttpLoadingManager.loadingError(res['data']._errstr)
                    }
                    reject(data)
                } else {
                    if (func == 'TransTopReq') {
                        if (data._param.param._errno) {
                            if (data._param.param._errno == 401) {
                                HttpLoadingManager.tokenError()
                            } else {
                                HttpLoadingManager.loadingError(data._param.param._errstr)
                            }
                            reject(data)
                        } else {
                            HttpLoadingManager.closeLoading(func)
                            resolve(data._param.param)
                        }
                    } else {
                        HttpLoadingManager.closeLoading(func)
                        resolve(data)
                    }
                }
            })
            .catch((err) => {
                HttpLoadingManager.loadingError('网络异常，请稍候重试')
                reject(err)
            })
    })
}

export default Post
